/**
 * Stub scenes — the few feature scenes not yet implemented (Chat: the chat hearth
 * lives inside Town for v1; Guild: guild life is M3). Rendered as a calm "coming
 * soon" card with tap-to-return so navigation to their keys is never a dead-end.
 * The renderer never owns rules; this is pure presentation.
 */
import Phaser from 'phaser';
import { COLORS, CSS, FONT, SPACING } from './ui/theme.js';
import { Layout } from './layout/index.js';
import { fadeIn, goTo } from './flow.js';

class StubScene extends Phaser.Scene {
  private readonly heading: string;
  private layout!: Layout;

  constructor(key: string, heading: string) {
    super(key);
    this.heading = heading;
  }

  create(): void {
    this.cameras.main.setBackgroundColor(COLORS.bg);
    this.layout = Layout.attach(this);

    const title = this.add
      .text(0, 0, this.heading, {
        fontFamily: FONT.family,
        fontSize: `${FONT.size.title}px`,
        color: CSS.text,
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    const sub = this.add
      .text(0, 0, 'Coming soon — this corner of town is still being built. 🌱', {
        fontFamily: FONT.family,
        fontSize: `${FONT.size.sm}px`,
        color: CSS.textMuted,
        align: 'center',
        wordWrap: { width: Math.min(420, this.layout.safe.width - SPACING.xxl) },
      })
      .setOrigin(0.5);

    const hint = this.add
      .text(0, 0, 'tap anywhere to head back', {
        fontFamily: FONT.family,
        fontSize: `${FONT.size.sm}px`,
        color: CSS.textMuted,
      })
      .setOrigin(0.5);

    const relayout = (): void => {
      const cx = this.layout.centerX;
      const cy = this.layout.centerY;
      title.setPosition(cx, cy - SPACING.xxl);
      sub.setPosition(cx, cy);
      hint.setPosition(cx, cy + SPACING.xxl);
    };
    relayout();
    this.layout.on('change', relayout);

    // Any tap returns to town — never strand a tired player on a blank scene.
    this.input.once('pointerdown', () => goTo(this, 'Town'));
    fadeIn(this);
  }
}

export class ChatScene extends StubScene {
  constructor() {
    super('Chat', 'Chat');
  }
}
export class GuildScene extends StubScene {
  constructor() {
    super('Guild', 'Guild Hall');
  }
}

export const STUB_SCENES = [ChatScene, GuildScene];
